<template>
    <template v-if="tipoUsuario === 'Administrador'">
        <MinutasAdmin></MinutasAdmin>
    </template >
    
    <template v-if="tipoUsuario === 'Supervisor'">
        <MinutasSupervisor></MinutasSupervisor>
    </template>

</template>   

<script>

import {EncryptService} from '@/services/EncryptService'
import MinutasAdmin from '@/views/minutas/MinutasAdmin.vue'
import MinutasSupervisor from '@/views/minutas/MinutasSupervisor.vue'

export default {
    name: 'NoticeComponent', 
    components: {       
        MinutasAdmin,
        MinutasSupervisor,        
    },
    data(){
        return{
            tipoUsuario:''
        }
    },
    async beforeMount(){        
        this.tipoUsuario = await EncryptService.decrypt(localStorage.getItem('TIPO'));       
    },   
}

</script>
